export const REPORT_PARAMETER_CONDITION_OPERATORS = [
  { label: 'เท่ากับ', value: 'equals' },
  { label: 'ไม่เท่ากับ', value: 'notEquals' },
  { label: 'อยู่ในรายการ', value: 'in' },
  { label: 'มีค่า', value: 'notEmpty' },
]

const getParameterField = (item = {}) => `${item.field || item.title || ''}`.trim()

const hasValue = (value) => {
  if (Array.isArray(value)) return value.length > 0
  if (value === null || typeof value === 'undefined') return false
  if (typeof value === 'string') return value.trim() !== ''

  return true
}

const normalizeComparableValue = (value) => `${value ?? ''}`

const getConditionValues = (value) => {
  if (Array.isArray(value)) return value
  if (typeof value !== 'string') return [value]

  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

const valuesAreEqual = (sourceValue, conditionValue) => {
  if (Array.isArray(sourceValue)) {
    return sourceValue.some(
      (value) => normalizeComparableValue(value) === normalizeComparableValue(conditionValue),
    )
  }

  return normalizeComparableValue(sourceValue) === normalizeComparableValue(conditionValue)
}

export const isReportParameterVisible = (item = {}, inputs = []) => {
  const condition = item.visibleWhen
  if (!condition?.field) return true

  const itemField = getParameterField(item)
  if (condition.field === itemField) return true

  const source = inputs.find(
    (input) => getParameterField(input) === `${condition.field}`.trim(),
  )
  if (!source) return false

  const operator = condition.operator || 'equals'
  if (operator === 'notEmpty') return hasValue(source.value)
  if (operator === 'notEquals') {
    return !valuesAreEqual(source.value, condition.value)
  }
  if (operator === 'in') {
    return getConditionValues(condition.value).some((value) =>
      valuesAreEqual(source.value, value),
    )
  }

  return valuesAreEqual(source.value, condition.value)
}

export const clearHiddenReportParameterValues = (inputs = []) => {
  let result = inputs.map((item) => ({ ...item }))

  for (let index = 0; index < result.length; index += 1) {
    let changed = false
    const nextResult = []

    for (let itemIndex = 0; itemIndex < result.length; itemIndex += 1) {
      const item = result[itemIndex]
      if (
        isReportParameterVisible(item, result) ||
        item.clearWhenHidden === false ||
        !hasValue(item.value)
      ) {
        nextResult.push(item)
        continue
      }

      changed = true
      nextResult.push({ ...item, value: '' })
    }

    result = nextResult

    if (!changed) break
  }

  return result
}

export const isReportParameterRequired = (item = {}, inputs = []) => {
  if (!isReportParameterVisible(item, inputs)) return false
  if (item.requiredWhenVisible === true) return true

  return item.optional !== true
}
